import React from "react";
import Modal from "react-bootstrap/Modal";

const LocationModal = ({
  show,
  onClose,
  location,
  setLocation,
  locationError,
  onSubmit,
  disableSubmit,
}) => {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Add Unit</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="input-block local-forms">
          <label>
            Location Name <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            value={location.name}
            onChange={(e) => setLocation("name", e.target.value)}
            placeholder="Enter Location name"
          />

          {locationError?.name && (
            <div className="error text-danger mt-1">{locationError.name}</div>
          )}
        </div>
        <div className="input-block local-forms">
          <label>
            Location Address <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            value={location.address}
            onChange={(e) => setLocation("address", e.target.value)}
            placeholder="Enter Location Address"
          />

          {locationError?.address && (
            <div className="error text-danger mt-1">
              {locationError.address}
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={onSubmit}
          disabled={disableSubmit}
        >
          {disableSubmit ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LocationModal;
